import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Pages/Login";
import LiveChatDashboard from "./Pages/LiveChatDashboard";
import ForgotPassword from "./Pages/ForgotPassword";
import ProtectedRoute from "./routes/ProtectedRoute";
import ChangePassword from "./Pages/ChangePassword";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* 🔐 Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/chat" element={<LiveChatDashboard />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
